module.exports = __webpack_public_path__ + "public/files/img/results.d7947170.gif";